import { render, staticRenderFns } from "./NewPc.vue?vue&type=template&id=074cbb6f&scoped=true&"
import script from "./NewPc.vue?vue&type=script&lang=js&"
export * from "./NewPc.vue?vue&type=script&lang=js&"
import style0 from "./NewPc.vue?vue&type=style&index=0&id=074cbb6f&prod&lang=css&"
import style1 from "./NewPc.vue?vue&type=style&index=1&id=074cbb6f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074cbb6f",
  null
  
)

export default component.exports